export var AdminMembersEvents;
(function (AdminMembersEvents) {
    AdminMembersEvents["CLICK_ADD_MEMBERS"] = "workportal_click_add_members";
})(AdminMembersEvents || (AdminMembersEvents = {}));
export var BillingEvents;
(function (BillingEvents) {
    BillingEvents["VIEW_PAYMENT_METHODS"] = "workportal_view_payment_methods";
})(BillingEvents || (BillingEvents = {}));
export var BillingPaymentCardEvents;
(function (BillingPaymentCardEvents) {
    BillingPaymentCardEvents["ADD_CARD_CLICK"] = "ddfw_payment_add_card_click";
    BillingPaymentCardEvents["DELETE_CARD_CLICK"] = "ddfw_payment_delete_card_click";
    BillingPaymentCardEvents["DELETE_CARD_SUCCESS"] = "ddfw_payment_delete_card_success";
    BillingPaymentCardEvents["SET_DEFAULT_CARD_CLICK"] = "ddfw_payment_set_default_card_click";
    BillingPaymentCardEvents["SUPPORT_LINK_CLICK"] = "ddfw_payment_support_link_click";
})(BillingPaymentCardEvents || (BillingPaymentCardEvents = {}));
export var BillingPaymentCardTrackingEvents;
(function (BillingPaymentCardTrackingEvents) {
    BillingPaymentCardTrackingEvents["ADD_METHOD_CLICK"] = "ddfw_payment_add_method_click";
    BillingPaymentCardTrackingEvents["ADD_METHOD_FAILURE"] = "ddfw_payment_add_method_failure";
    BillingPaymentCardTrackingEvents["ADD_METHOD_MENU_CLICKED"] = "ddfw_payment_add_method_menu_clicked";
    BillingPaymentCardTrackingEvents["ADD_METHOD_SUCCESS"] = "ddfw_payment_add_method_success";
    BillingPaymentCardTrackingEvents["ADD_MODAL_TAPPED_BACK"] = "ddfw_payment_add_modal_tapped_back";
})(BillingPaymentCardTrackingEvents || (BillingPaymentCardTrackingEvents = {}));
export var DashPassEvents;
(function (DashPassEvents) {
    DashPassEvents["SELF_SERVE_BENEFIT_ACTIVATION"] = "self_serve_benefit_activation";
    DashPassEvents["SELF_SERVE_BENEFIT_DEACTIVATION"] = "self_serve_benefit_deactivation";
    DashPassEvents["SELF_SERVE_DASHPASS_PAGE_VIEW"] = "self_serve_dashpass_page_view";
    DashPassEvents["SUBSCRIBED"] = "dashpass_subscribed";
    DashPassEvents["SUBSCRIBED_GET_HELP_CLICK"] = "dashpass_subscribed_get_help_click";
    DashPassEvents["UNSUBSCRIBED"] = "dashpass_unsubscribed";
    DashPassEvents["UNSUBSCRIBED_LEARN_MORE_CLICK"] = "dashpass_unsubscribed_learn_more_click";
})(DashPassEvents || (DashPassEvents = {}));
export var EmployeesEvents;
(function (EmployeesEvents) {
    EmployeesEvents["REMOVE_MEMBERS"] = "workportal_remove_members";
    EmployeesEvents["SUBMIT_ADD_MEMBERS"] = "workportal_submit_add_members";
})(EmployeesEvents || (EmployeesEvents = {}));
export var GroupsEvents;
(function (GroupsEvents) {
    GroupsEvents["CLICK_CREATE_GROUP"] = "workportal_click_create_group";
    GroupsEvents["GROUPS"] = "workportal_groups";
    GroupsEvents["SUBMIT_ADD_GROUP"] = "workportal_submit_add_group";
    GroupsEvents["SUBMIT_DELETE_GROUP"] = "workportal_submit_delete_group";
    GroupsEvents["SUBMIT_EDIT_GROUP"] = "workportal_submit_edit_group";
})(GroupsEvents || (GroupsEvents = {}));
export var GroupsMembersEvents;
(function (GroupsMembersEvents) {
    GroupsMembersEvents["GROUPS_MEMBERS_LIST"] = "workportal_groups_members_list";
    GroupsMembersEvents["SUBMIT_REMOVE_GROUP_MEMBER"] = "workportal_submit_remove_group_member";
})(GroupsMembersEvents || (GroupsMembersEvents = {}));
export var HeaderEvents;
(function (HeaderEvents) {
    HeaderEvents["CLICK_SETTINGS"] = "workportal_click_settings";
})(HeaderEvents || (HeaderEvents = {}));
export var JoinPageEvents;
(function (JoinPageEvents) {
    JoinPageEvents["VIEW_JOIN_PAGE_PENDING"] = "workportal_view_join_page_pending";
    JoinPageEvents["VIEW_JOIN_PAGE_SUCCESS"] = "workportal_view_join_page_success";
})(JoinPageEvents || (JoinPageEvents = {}));
export var MealBudgetsEvents;
(function (MealBudgetsEvents) {
    MealBudgetsEvents["CLICK_ADD_BUDGET"] = "workportal_click_add_budget";
    MealBudgetsEvents["DELETE_BUDGET"] = "workportal_delete_budget";
    MealBudgetsEvents["EDIT_BUDGET"] = "workportal_edit_budget";
    MealBudgetsEvents["EXPENSED_MEALS_LEARN_MORE_CLICK"] = "expensed_meals_learn_more_click";
    MealBudgetsEvents["EXPENSED_MEALS_UNSUBSCRIBED"] = "expensed_meals_unsubscribed";
    MealBudgetsEvents["SUBMIT_ADD_BUDGET"] = "workportal_submit_add_budget";
    MealBudgetsEvents["VIEW_BUDGETS"] = "workportal_view_budgets";
})(MealBudgetsEvents || (MealBudgetsEvents = {}));
export var OrderHistoryEvents;
(function (OrderHistoryEvents) {
    OrderHistoryEvents["ORDER_HISTORY"] = "workportal_order_history";
})(OrderHistoryEvents || (OrderHistoryEvents = {}));
export var SelfServeProductOptionsEvents;
(function (SelfServeProductOptionsEvents) {
    SelfServeProductOptionsEvents["DASHPASS_SIGN_UP"] = "work_portal_self_serve_dashpass_sign_up";
    SelfServeProductOptionsEvents["EXPENSED_MEALS_SIGN_UP"] = "work_portal_self_serve_expensed_meals_sign_up";
    SelfServeProductOptionsEvents["VIEW_TALK_SALES_MODAL"] = "work_portal_self_serve_view_talk_to_sales_modal";
})(SelfServeProductOptionsEvents || (SelfServeProductOptionsEvents = {}));
export var SelfServeSignupTeamEvents;
(function (SelfServeSignupTeamEvents) {
    SelfServeSignupTeamEvents["DASHPASS_CREATE_TEAM"] = "work_portal_self_serve_dashpass_create_team";
    SelfServeSignupTeamEvents["DASHPASS_CREATE_TEAM_SUCCESS"] = "work_portal_self_serve_dashpass_create_team_success";
    SelfServeSignupTeamEvents["EXPENSED_MEALS_CREATE_TEAM"] = "work_portal_self_serve_expensed_meals_create_team";
    SelfServeSignupTeamEvents["EXPENSED_MEALS_CREATE_TEAM_SUCCESS"] = "work_portal_self_serve_expensed_meals_create_team_success";
})(SelfServeSignupTeamEvents || (SelfServeSignupTeamEvents = {}));
export var TeamNotFoundEvents;
(function (TeamNotFoundEvents) {
    TeamNotFoundEvents["VIEW_EMAIL_NOT_FOUND_PAGE"] = "workportal_view_email_not_found_page";
})(TeamNotFoundEvents || (TeamNotFoundEvents = {}));
